module.exports = __webpack_public_path__ + "static/media/noun-car-door-1643574-142350.703e3cc2.svg";